/*
 * @Author: your name
 * @Date: 2020-09-25 10:34:43
 * @LastEditTime: 2021-01-14 21:19:20
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /xdap-h5/src/api/component/index.js
 */
export default {
  module: 'COMPONENT',
  // 附件上传组件上传文件接口
  FORM_UPLOAD_CONFIG_API: {
    url: '/xdap-app/attachments/simpleUploadFile',
    method: 'post',
    disableSuccessMsg: true
  },
  // 附件删除
  FORM_UPLOAD_CONFIG_DELETE: {
    url: '/xdap-app/attachments/deleteFile',
    method: 'get'
  },
  // 查询平铺部门
  QUERY_ALL_DEPARTMENT: {
    url: '/xdap-app/department/select/queryDeptList',
    method: 'get',
    disableSuccessMsg: true
  },
  // 获取顶级部门
  QUERY_TOP_DEPARTMENT: {
    url: '/xdap-app/department/select/queryTopDeptList',
    method: 'get',
    disableSuccessMsg: true
  },
  // 获取子部门
  QUERY_CHILD_DEPARTMENT: {
    url: '/xdap-app/department/select/querySecondaryDeptList',
    method: 'get',
    disableSuccessMsg: true
  },
  // 通过数据过滤后的部门
  QUERY_DEPARTMENT_FILTER: {
    url: '/xdap-app/department/select/queryDepartmentFilter',
    method: 'post',
    disableSuccessMsg: true
  },
  // 关联表单查询列表配置
  QUERY_COMPONENT_LIST: {
    url: '/xdap-app/formConfig/query/listAllComponents',
    method: 'get',
    disableSuccessMsg: true
  },
  // 关联表单查询表格数据
  QUERY_ASSOCIATED_TABLE: {
    url: '/xdap-app/business/query/tableOrList',
    method: 'post',
    disableSuccessMsg: true
  },
  QUERY_LIST_BUSINESS_DATA: { // 数据选择列表数据
    url: '/xdap-app/business/query/dataSelectorData',
    method: 'post',
    disableSuccessMsg: true
  },
  // 表格关联表单数据查询
  QUERY_ASSOCIATED_TABLE_FOR_TABLE: {
    url: '/xdap-app/business/query/tableAssFormTableOrList',
    method: 'post',
    disableSuccessMsg: true
  },
  // 数据选择打开的关联表单详情
  QUERY_ASSOCIATED_DETAIL: {
    url: '/xdap-app/business/query/formDetails',
    method: 'post',
    disableSuccessMsg: true
  },
  // 查询列表可使用的平铺组件
  QUERY_LIST_COMPONENTS: {
    url: '/xdap-app/formConfig/query/listAllComponents',
    method: 'get',
    disableSuccessMsg: true
  },
  QUERY_LIST_COMPONENTS_SORT: {
    url: '/xdap-app/formConfig/query/listAllComponentsSort',
    method: 'get',
    disableSuccessMsg: true
  },
  QUERY_AREA: {
    url: '/xdap-admin/province/query/province',
    method: 'post',
    disableSuccessMsg: true
  },
  // 查数据统计组件的数据
  QUERY_STATISTICS_VALUE_COLUME: {
    url: '/xdap-app/business/query/dataStatisticValue',
    method: 'post',
    disableSuccessMsg: true
  },
  FORM_ORC_UPLOAD_API: {
    url: '/xdap-app/ocr/executeOcr',
    method: 'post',
    disableSuccessMsg: true
  },
  FORM_ORC_UPLOAD_WX_API: {
    url: '/xdap-app/ocr/wxExecuteOcr',
    method: 'post',
    disableSuccessMsg: true
  }
}
